import React, {useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import StepperSidebar from '@/components/stepper/StepperSidebar';
import BasicDetails from '@/pages/admin/Stepper/BasicDetails';
import ProductDetails from '@/pages/admin/Stepper/ProductDetails';
import ChoosePlan from '@/pages/admin/Stepper/ChoosePlan';
import ConfirmStep from '@/pages/admin/Stepper/ConfirmStep';
import PaymentFail from '@/pages/admin/Stepper/PaymentFail';
import { connect } from "react-redux";
import { getSupplierMember } from "@/actions/stepperAction";

const StepperContainer = (props) => {
  const { id } = useParams();

  const totalSteps = 4;

  const handleNext = () => {
    if (props.activeStep < totalSteps) {
      props.setActiveStep((prev) => {
        console.log("handleNext ============ ", prev)
        return (prev + 1)
      });
    }
  };

  const handlePrev = () => {
    if (props.activeStep > 1) {
      props.setActiveStep((prev) => {
        console.log("handlePrev  =========== ", prev)
        return (prev - 1)
      });
    }
  };

  const handleSupplierUpdated = async () => {
    console.log(
      "Supplier updated -> getting latest data"
    );

    await props.fetchSupplier(false);
  };
  
    
    const renderStep=()=>{
       switch(props.activeStep){
          case 1:
            return <BasicDetails setActiveStep={props.setActiveStep} supplierMember={props.supplierMember} supplier_id={id} onNext={handleNext} onSupplierUpdated={
              handleSupplierUpdated
            } /> ;
          case 2:
            return <ProductDetails setActiveStep={props.setActiveStep} onNext={handleNext} supplier_id={id} onPrev={handlePrev} onSupplierUpdated={
              handleSupplierUpdated
            }/>;  
          case 3:
            return <ChoosePlan setActiveStep={props.setActiveStep} onNext={handleNext} supplierMember={props.supplierMember} supplier_id={id} onPrev={handlePrev} onSupplierUpdated={
              handleSupplierUpdated} />;
          case 4:
             return <ConfirmStep setActiveStep={props.setActiveStep}  supplierMember={props.supplierMember} onPrev={handlePrev} supplier_id={id} />;
            // return <PaymentFail setActiveStep={setActiveStep}  />;
          default:
             return <div>Step not found</div>;      
       }
    }


  return (
    <>
      <div className='layout-wrape'>
        <div className='container-fluid'>
            <div className='row stepper-layout'>
                <div className='col-12 col-md-4 col-xl-3 sidebar-wrap px-xxl-4'>
                    <StepperSidebar activeStep={props.activeStep} percentage={props.percentage}/>
                </div>
                <div className='col-12 col-md-8 col-xl-9 content-wrap'>
                 
                     {renderStep(props.activeStep)}
                
                </div>
            </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
   
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSupplier: (member_id) => dispatch(getSupplierMember(member_id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StepperContainer);

